import './vendor';

import './_parts/_favourite';
import './_parts/_select';
import './_parts/_header';
import './_parts/_header-search';
import './_parts/_banner-slider';
import './_parts/_cinema-slider';
import './_parts/_cinema-filter';
import './_parts/_map';
import './_parts/_yandex-map';
import './_parts/_validate';
import './_parts/_mask';
import './_parts/_file-load';
import './_parts/_partners-slider';
import './_parts/_afisha-slider';
import './_parts/_menu';
import './_parts/_lightbox';
import './_parts/_promo';
import './_parts/_faq';
import './_parts/_scroll';
import './_parts/_mapstore';
import './_parts/_mapstore-menu';
import './_parts/_input-search';
import './_parts/_business-form';
import './_parts/_filter-form';
import './_parts/_subscribe-form';
import './_parts/_instagram-slider';
